// extracted by mini-css-extract-plugin
module.exports = {"warning_msg":"Alert_warning_msg__cuyBF","error_msg":"Alert_error_msg__FlBAX"};